import { AgGridEvent, GridApi } from 'ag-grid-community'

export const gridEventsLogger = (gridApi: GridApi) => {
  gridApi.addGlobalListener(function listenAgGridEvents(type: string, event: AgGridEvent) {
    console.log('AG Grid Events ::: type ::: ', type, ' ::: event ::: ', event)
  })
}
